import { cn } from '@/lib/utils';

type FlexType = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  gap?: string;
};

function FlexBase({ className, gap, ...props }: FlexType) {
  return <div className={cn(`flex`, className, gap && `gap-${gap}`)} {...props}></div>;
}

function Row({ className, ...props }: FlexType) {
  return <FlexBase className={cn(`flex-row`, className)} {...props}></FlexBase>;
}

function Col({ className, ...props }: FlexType) {
  return <FlexBase className={cn(`flex-col`, className)} {...props}></FlexBase>;
}

const Flex = {
  Row,
  Col,
};

export default Flex;
